import { FormattedMessage } from "react-intl";
import { ITextDetailBase } from "../../../../ui/TextDetail/module/constants";
import { IManagedUser } from "../../../../models/User";
import messages from "./messages";

export const createUserEntitlementReferenceFieldList = (
  selectedUser: IManagedUser
): ITextDetailBase[] => {
  const userEntitlementReferenceFiledList: ITextDetailBase[] = [
    {
      label: <FormattedMessage {...messages.PanelDetailRequestLabelID} />,
      value: selectedUser.code,
    },
    {
      label: <FormattedMessage {...messages.PanelDetailRequestLabelName} />,
      value: selectedUser.name,
    },
    {
      label: <FormattedMessage {...messages.PanelDetailRequestLabelSurname} />,
      value: selectedUser.surname,
    },
    {
      label: <FormattedMessage {...messages.PanelDetailRequestLabelType} />,
      value: selectedUser.type,
    },
    {
      label: <FormattedMessage {...messages.PanelDetailRequestLabelCompany} />,
      value: selectedUser.company,
    },
    {
      label: <FormattedMessage {...messages.PanelDetailRequestLabelManager} />,
      value:
        selectedUser.resp_full_name && selectedUser.resp_code
          ? `${selectedUser.resp_full_name} [${selectedUser.resp_code}]`
          : selectedUser.resp_full_name && !selectedUser.resp_code
          ? selectedUser.resp_full_name
          : "ND",
    },
    {
      label: <FormattedMessage {...messages.PanelDetailRequestLabelOU} />,
      value: selectedUser.organizational_unit!,
    },
    {
      label: <FormattedMessage {...messages.PanelDetailRequestLabelIdentity} />,
      value: selectedUser.identitySystemId!,
    },
  ];
  return userEntitlementReferenceFiledList;
};
